import { render } from "./DaiwariFormattingLeft.vue?vue&type=template&id=20f5d966&scoped=true"
import script from "./DaiwariFormattingLeft.vue?vue&type=script&lang=js"
export * from "./DaiwariFormattingLeft.vue?vue&type=script&lang=js"

import "./DaiwariFormattingLeft.vue?vue&type=style&index=0&id=20f5d966&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f5d966"]])

export default __exports__